import { render } from "./InvestmentInfoCard.vue?vue&type=template&id=17bf26f4&scoped=true"
import script from "./InvestmentInfoCard.vue?vue&type=script&lang=js"
export * from "./InvestmentInfoCard.vue?vue&type=script&lang=js"

import "./InvestmentInfoCard.vue?vue&type=style&index=0&id=17bf26f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bf26f4"]])

export default __exports__